(function () {
    'use strict';

    angular
        .module('appback')
        .controller('WorkflowsEspaciosController', WorkflowsEspaciosController)
        .controller('WorkflowsEspacioController', WorkflowsEspacioController)
        .controller('WorkflowsTiposController', WorkflowsTiposController)
        .controller('WorkflowsController', WorkflowsController)

    WorkflowsEspaciosController.$inject = ["$timeout", "WorkflowsService"];
    WorkflowsEspacioController.$inject = ["$scope", "WorkflowsService"];
    WorkflowsTiposController.$inject = ["WorkflowsService"];
    WorkflowsController.$inject = ["$q", "$scope", "$timeout", "WorkflowsService"];

    /**
     * Índice de "Workflows" (backend/views/workflows/index.php): una card por
     * espacio que lleva a sus tipos de contenido (workflows/espacio). El admin
     * crea espacios con el asistente del popup #espacioAsistenteModal: 1)
     * nombre, icono y color, 2) tipos de contenido, 3) guardar.
     */
    function WorkflowsEspaciosController($timeout, WorkflowsService) {
        var es = this;
        var asistenteModal = null;

        es.loading = false;
        es.error = false;
        es.espacios = [];
        es.busqueda = '';
        es.urlEspacio = '';
        es.urlEditar = '';
        es.esAdmin = false;
        es.asistente = null;
        es.iconos = ['folder', 'home', 'work', 'school', 'shopping_cart', 'favorite', 'star', 'rocket_launch', 'science', 'payments', 'groups', 'campaign', 'support_agent', 'inventory_2', 'build', 'flight', 'restaurant', 'fitness_center', 'palette', 'code'];
        es.colores = ['#4b41e1', '#2196F3', '#00BCD4', '#009688', '#4CAF50', '#8BC34A', '#FFC107', '#FF9800', '#F44336', '#E91E63', '#9C27B0', '#607D8B'];

        es.init = function (urlEspacio, esAdmin, urlEditar) {
            es.urlEspacio = urlEspacio;
            es.urlEditar = urlEditar || '';
            es.esAdmin = !!esAdmin;
            es.cargar();
        };

        es.cargar = function () {
            es.loading = true;
            es.error = false;

            return WorkflowsService.Espacios().then(function (espacios) {
                es.espacios = espacios || [];
            }, function () {
                es.error = true;
            }).finally(function () {
                es.loading = false;
            });
        };

        es.espaciosFiltrados = function () {
            var texto = (es.busqueda || '').toLowerCase();

            return es.espacios.filter(function (espacio) {
                return !texto || espacio.name.toLowerCase().indexOf(texto) !== -1;
            });
        };

        es.url = function (espacio) {
            return es.urlEspacio + (es.urlEspacio.indexOf('?') === -1 ? '?' : '&') + 'id=' + encodeURIComponent(espacio.id);
        };

        // Popup de alta: solo nombre, icono y color. Al guardar lleva a la edición del espacio, donde se eligen sus tipos de contenido.
        es.abrirAsistente = function () {
            es.asistente = {
                name: '',
                icon: es.iconos[0],
                color: es.colores[0],
                saving: false,
                error: null,
            };

            if (!asistenteModal) {
                asistenteModal = new bootstrap.Modal(document.getElementById('espacioAsistenteModal'));
            }
            asistenteModal.show();
        };

        es.guardar = function () {
            var asistente = es.asistente;
            if (!asistente || asistente.saving || !(asistente.name || '').trim()) {
                return;
            }
            asistente.saving = true;
            asistente.error = null;

            WorkflowsService.CrearEspacio({
                name: asistente.name.trim(),
                icon: asistente.icon,
                color: asistente.color,
            }).then(function (data) {
                window.location.href = es.urlEditar + (es.urlEditar.indexOf('?') === -1 ? '?' : '&') + 'id=' + encodeURIComponent(data.id);
            }, function (data) {
                var errores = (data && data.errors) || {};
                for (var campo in errores) {
                    if (errores[campo] && errores[campo].length) {
                        asistente.error = errores[campo][0];
                        break;
                    }
                }
                asistente.error = asistente.error || 'No se ha podido guardar el espacio.';
                asistente.saving = false;
            });
        };
    }

    /**
     * Vista y edición de un espacio (backend/views/workflows/espacio.php): sus
     * tipos de contenido padre y, al elegir uno, los subtipos vinculados (los de
     * las relations() de su modelo), más los workflows del usuario en el
     * espacio. En edición (es.editable, solo el admin) se cambian nombre, icono
     * y color y se marcan los tipos padre y los subtipos vinculados. es.filas
     * son los TypesSpace del espacio: {type, esPadre, tipoPadre}.
     */
    function WorkflowsEspacioController($scope, WorkflowsService) {
        var es = this;

        es.loading = false;
        es.error = false;
        es.saving = false;
        es.errorGuardar = null;
        es.editable = false;
        es.esAdmin = false;
        es.urls = {};
        es.datos = null;
        es.espacio = null;
        es.filas = [];
        es.estados = [];
        es.seleccionado = null;
        es.busqueda = '';
        es.iconos = ['folder', 'home', 'work', 'school', 'shopping_cart', 'favorite', 'star', 'rocket_launch', 'science', 'payments', 'groups', 'campaign', 'support_agent', 'inventory_2', 'build', 'flight', 'restaurant', 'fitness_center', 'palette', 'code'];
        es.colores = ['#4b41e1', '#2196F3', '#00BCD4', '#009688', '#4CAF50', '#8BC34A', '#FFC107', '#FF9800', '#F44336', '#E91E63', '#9C27B0', '#607D8B'];

        var id = null;

        es.init = function (config) {
            id = config.id;
            es.editable = !!config.editable;
            es.esAdmin = !!config.esAdmin;
            es.urls = config.urls || {};
            es.loading = true;

            WorkflowsService.EspacioDatos(id).then(function (datos) {
                es.datos = datos;
                es.espacio = angular.copy(datos.espacio);
                es.filas = angular.copy(datos.filas);
                es.estados = angular.copy(datos.estados);
                es.seleccionado = es.padres().length ? es.padres()[0].type : null;
            }, function () {
                es.error = true;
            }).finally(function () {
                es.loading = false;
            });
        };

        // Al guardar un workflow en el panel del espacio (WorkflowsController) se recuentan los del resumen.
        $scope.$on('workflows:guardado', function () {
            WorkflowsService.EspacioDatos(id).then(function (datos) {
                es.datos.workflows = datos.workflows;
            });
        });

        // Estados de las tareas (columnas del tablero): solo el admin, en edición.
        es.agregarEstado = function () {
            es.estados.push({ id: null, name: '', backgroundColor: '#E0E0E0', onBackgroundColor: '#000000', isDefault: !es.estados.length });
        };

        es.quitarEstado = function (index) {
            var quitado = es.estados.splice(index, 1)[0];
            if (quitado && quitado.isDefault && es.estados.length) {
                es.estados[0].isDefault = true;
            }
        };

        es.moverEstado = function (index, delta) {
            var destino = index + delta;
            if (destino < 0 || destino >= es.estados.length) {
                return;
            }
            var estado = es.estados.splice(index, 1)[0];
            es.estados.splice(destino, 0, estado);
        };

        es.marcarPorDefecto = function (estado) {
            es.estados.forEach(function (otro) {
                otro.isDefault = otro === estado;
            });
        };

        es.estadosValidos = function () {
            return es.estados.length > 0 && es.estados.every(function (estado) {
                return !!(estado.name || '').trim();
            });
        };

        es.titulo = function (type) {
            var tipo = es.datos && es.datos.tipos.filter(function (candidato) {
                return candidato.type === type;
            })[0];

            return tipo ? tipo.title : type;
        };

        es.esPadre = function (type) {
            return es.filas.some(function (fila) {
                return fila.esPadre && fila.type === type;
            });
        };

        es.esHijo = function (type, padre) {
            return es.filas.some(function (fila) {
                return !fila.esPadre && fila.type === type && fila.tipoPadre === padre;
            });
        };

        es.contarHijos = function (padre) {
            return es.filas.filter(function (fila) {
                return !fila.esPadre && fila.tipoPadre === padre;
            }).length;
        };

        // En lectura, solo los tipos padre del espacio; en edición, todos (con buscador) para poder marcarlos.
        es.padres = function () {
            if (!es.datos) {
                return [];
            }
            var texto = (es.busqueda || '').toLowerCase();

            return es.datos.tipos.filter(function (tipo) {
                return es.editable ? (!texto || tipo.title.toLowerCase().indexOf(texto) !== -1) : es.esPadre(tipo.type);
            });
        };

        es.hijosPosibles = function (padre) {
            return (es.datos && es.datos.hijos[padre]) || [];
        };

        // Los vinculados al padre elegido en el espacio, y (en edición) los relacionados con él que aún no lo están.
        es.vinculados = function () {
            return es.hijosPosibles(es.seleccionado).filter(function (hijo) {
                return es.esHijo(hijo.type, es.seleccionado);
            });
        };

        es.disponibles = function () {
            return es.hijosPosibles(es.seleccionado).filter(function (hijo) {
                return !es.esHijo(hijo.type, es.seleccionado);
            });
        };

        es.seleccionar = function (type) {
            es.seleccionado = type;
        };

        // Clic en la card de un tipo: lo elige para ver sus subtipos; en edición, si aún no es padre, lo marca como padre.
        es.pulsarTipo = function (type) {
            if (es.editable && !es.esPadre(type)) {
                es.alternarPadre(type);
            } else {
                es.seleccionar(type);
            }
        };

        es.alternarPadre = function (type) {
            if (es.esPadre(type)) {
                // Dejar de ser padre quita también sus subtipos vinculados.
                es.filas = es.filas.filter(function (fila) {
                    return !((fila.esPadre && fila.type === type) || (!fila.esPadre && fila.tipoPadre === type));
                });
            } else {
                es.filas.push({ type: type, esPadre: true, tipoPadre: '' });
                es.seleccionado = type;
            }
        };

        es.alternarHijo = function (type) {
            var padre = es.seleccionado;
            if (es.esHijo(type, padre)) {
                es.filas = es.filas.filter(function (fila) {
                    return !(!fila.esPadre && fila.type === type && fila.tipoPadre === padre);
                });
            } else {
                es.filas.push({ type: type, esPadre: false, tipoPadre: padre });
            }
        };

        // Siempre los mismos objetos (solo cambia su valor): con uno nuevo en cada llamada, el ng-repeat no se estabiliza ($rootScope:infdig).
        var tiles = [
            { icono: 'folder_open', titulo: 'Tipos padre', valor: 0 },
            { icono: 'account_tree', titulo: 'Subtipos vinculados', valor: 0 },
            { icono: 'view_kanban', titulo: 'Estados', valor: 0 },
            { icono: 'schema', titulo: 'Workflows activos', valor: 0 },
        ];

        es.resumen = function () {
            var workflows = es.datos.workflows;

            tiles[0].valor = es.filas.filter(function (fila) { return fila.esPadre; }).length;
            tiles[1].valor = es.filas.filter(function (fila) { return !fila.esPadre; }).length;
            tiles[2].valor = es.estados.length;
            tiles[3].valor = workflows.filter(function (workflow) { return workflow.activo; }).length + '/' + workflows.length;

            return tiles;
        };

        es.guardar = function () {
            if (es.saving) {
                return;
            }
            es.saving = true;
            es.errorGuardar = null;

            WorkflowsService.GuardarEspacio(id, {
                name: es.espacio.name.trim(),
                icon: es.espacio.icon,
                color: es.espacio.color,
                tipos: es.filas,
                estados: es.estados,
            }).then(function () {
                window.location.href = es.urls.ver;
            }, function (data) {
                var errores = (data && data.errors) || {};
                for (var campo in errores) {
                    if (errores[campo] && errores[campo].length) {
                        es.errorGuardar = errores[campo][0];
                        break;
                    }
                }
                es.errorGuardar = es.errorGuardar || 'No se ha podido guardar el espacio.';
                es.saving = false;
            });
        };
    }

    /**
     * Tipos de contenido de un espacio (backend/views/workflows/espacio.php): una
     * card por tipo (con cuántos workflows tiene el usuario en cada uno)
     * que lleva a su vista (workflows/tipo, ver WorkflowsController).
     */
    function WorkflowsTiposController(WorkflowsService) {
        var tp = this;

        tp.loading = false;
        tp.error = false;
        tp.tipos = [];
        tp.busqueda = '';
        tp.urlTipo = '';

        tp.init = function (urlTipo, espacioId) {
            tp.urlTipo = urlTipo;
            tp.loading = true;

            WorkflowsService.Tipos(espacioId).then(function (tipos) {
                tp.tipos = tipos || [];
            }, function () {
                tp.error = true;
            }).finally(function () {
                tp.loading = false;
            });
        };

        // Primero los workflows programables (sin tipo de contenido), luego los
        // tipos que ya tienen workflow, el resto por título.
        tp.tiposFiltrados = function () {
            var texto = (tp.busqueda || '').toLowerCase();

            return tp.tipos.filter(function (tipo) {
                return !texto || tipo.title.toLowerCase().indexOf(texto) !== -1;
            }).sort(function (a, b) {
                if (!!a.programable !== !!b.programable) {
                    return a.programable ? -1 : 1;
                }
                if (!!a.workflow !== !!b.workflow) {
                    return a.workflow ? -1 : 1;
                }
                return a.title.localeCompare(b.title);
            });
        };

        tp.url = function (tipo) {
            return tp.urlTipo + (tp.urlTipo.indexOf('?') === -1 ? '?' : '&') + 'nodeType=' + encodeURIComponent(tipo.type);
        };
    }

    /**
     * Vista de un tipo de contenido (backend/views/workflows/tipo.php): a la
     * izquierda sus workflows, uno debajo de otro (wf.workflows, wf.workflow
     * es el elegido); a la derecha las programaciones del elegido (wf.prog).
     * Los workflows se crean y se editan con el asistente del popup
     * #workflowAsistenteModal (wf.asistente): 1) pasos, 2) programación
     * opcional, 3) resumen y guardar. Al editar se trabaja sobre una copia
     * (wf.asistente.workflow) que solo pasa al listado al guardarse. La tarea
     * de un paso se elige en el catálogo (wf.catalogo, un popup encima del
     * asistente con una pestaña para las Tasks del sistema y otra para los
     * prompts del usuario, common\models\UserPrompt de tipo "prompt"). Un
     * prompt se puede escribir o editar desde el propio paso (::guardarPrompt()).
     */
    function WorkflowsController($q, $scope, $timeout, WorkflowsService) {
        var wf = this;

        wf.error = false;
        wf.tareas = [];
        wf.selected = null;
        wf.cargando = false;
        wf.errorCarga = null;
        wf.workflows = [];
        wf.workflow = null;
        wf.puedeProgramar = false;
        wf.puedeCrearProgramacion = false;
        wf.puedeMarcarPorDefecto = false;
        wf.asistente = null;
        wf.catalogo = null;
        wf.diasIniciales = {};
        wf.esfuerzos = [];
        wf.nodeType = '';
        wf.urls = {};
        wf.prog = { workflowId: null, lista: [], cargando: false, error: false };

        /**
         * @param {Object} config tipo ({type, title}), puedeProgramar,
         *   puedeCrearProgramacion, puedeMarcarPorDefecto (el admin), diasIniciales, esfuerzos ({id, nombre, minutos}, para el
         *   formulario de prompt), nodeType (el de las programaciones) y urls
         *   de las programaciones (con __ID__ y __LANG__), ver la vista.
         */
        wf.init = function (config) {
            wf.puedeProgramar = !!config.puedeProgramar;
            wf.puedeCrearProgramacion = !!config.puedeCrearProgramacion;
            wf.puedeMarcarPorDefecto = !!config.puedeMarcarPorDefecto;
            wf.diasIniciales = config.diasIniciales || {};
            wf.esfuerzos = config.esfuerzos || [];
            wf.nodeType = config.nodeType || '';
            wf.urls = config.urls || {};
            wf.espacioId = config.espacioId || null;

            WorkflowsService.Tareas().then(function (tareas) {
                wf.tareas = tareas || [];
            }, function () {
                wf.error = true;
            });
            wf.seleccionar(config.tipo);
        };

        // __ID__ es el id de la programación (o del workflow, al crearla) y
        // __LANG__ su lang_id: altcrm busca el contenido por los dos.
        wf.url = function (accion, id, langId) {
            return (wf.urls[accion] || '')
                .replace('__ID__', encodeURIComponent(id))
                .replace('__LANG__', encodeURIComponent(langId || 1));
        };

        // Borra la programación (POST a altcrm/content/borrarcontenido, el
        // mismo borrado que el grid de altcrm: la deja inactiva) y la quita
        // del panel sin recargar la página.
        wf.borrarProgramacion = function (programacion) {
            if (programacion.borrando || !window.confirm('¿Seguro que quieres eliminar esta programación?')) {
                return;
            }

            programacion.borrando = true;
            WorkflowsService.BorrarContenido(wf.url('borrar', programacion.id), programacion.id, wf.nodeType).then(function () {
                var index = wf.prog.lista.indexOf(programacion);
                if (index !== -1) {
                    wf.prog.lista.splice(index, 1);
                }
            }, function () {
                programacion.borrando = false;
                wf.prog.error = true;
            });
        };

        // Sin días marcados, la programación corre todos los días.
        wf.diaActivo = function (programacion, dia) {
            return !programacion.dias.length || programacion.dias.indexOf(parseInt(dia, 10)) !== -1;
        };

        wf.seleccionar = function (tipo) {
            wf.selected = tipo;
            wf.workflows = [];
            wf.workflow = null;
            wf.errorCarga = null;
            wf.cargando = true;

            WorkflowsService.Cargar(tipo.type, wf.espacioId).then(function (data) {
                if (wf.selected !== tipo) {
                    return;
                }
                wf.workflows = (data || []).map(function (datos) {
                    var workflow = vacio();
                    workflow.id = datos.id;
                    workflow.activo = !!datos.activo;
                    workflow.activoGuardado = workflow.activo;
                    workflow.titulo = datos.titulo || '';
                    workflow.isDefault = !!datos.is_default;
                    workflow.steps = datos.steps || [];
                    return workflow;
                });
                // Sin workflows, la vista ofrece crear el primero con el asistente.
                if (wf.workflows.length) {
                    wf.elegirWorkflow(wf.workflows[0]);
                }
            }, function () {
                wf.errorCarga = 'No se han podido cargar los workflows.';
            }).finally(function () {
                wf.cargando = false;
            });
        };

        wf.elegirWorkflow = function (workflow) {
            wf.workflow = workflow;
            cargarProgramaciones();
        };

        var asistenteModal = null;

        // Abre el asistente en su paso 1: sin workflow, para crear uno nuevo
        // (con un paso vacío ya puesto, solo hay que elegir la tarea); con
        // workflow, para editar una copia suya. Al editar lo deja elegido,
        // para que el paso 2 cuente sus programaciones.
        wf.abrirAsistente = function (original) {
            var workflow;
            if (original) {
                if (wf.workflow !== original) {
                    wf.elegirWorkflow(original);
                }
                workflow = angular.copy(original);
                workflow.activo = !!original.activoGuardado;
                workflow.steps.forEach(function (step) {
                    step.conCondicion = !!step.condition;
                });
            } else {
                workflow = vacio();
                workflow.activo = true;
            }
            wf.catalogo = null;
            wf.asistente = {
                paso: 1,
                original: original || null,
                workflow: workflow,
                programar: false,
                programacion: { hora: '09:00', dias: [] },
                saving: false,
                error: null,
            };
            if (!workflow.steps.length) {
                workflow.steps.push(pasoVacio());
            }

            if (!asistenteModal) {
                asistenteModal = new bootstrap.Modal(document.getElementById('workflowAsistenteModal'));
            }
            asistenteModal.show();
        };

        // Paso 1: al menos un paso, todos con su tarea, con su condición si
        // es "Solo si" y sin un prompt a medio escribir. Paso 2: si se
        // programa, con hora.
        wf.puedeAvanzar = function () {
            var asistente = wf.asistente;
            if (!asistente) {
                return false;
            }
            if (asistente.paso === 1) {
                var steps = asistente.workflow.steps;
                return steps.length > 0 && steps.every(function (step) {
                    return !!step.slug && !step.nuevoPrompt && (!step.conCondicion || !!(step.condition || '').trim());
                });
            }
            if (asistente.paso === 2) {
                return !asistente.programar || /^([01]\d|2[0-3]):[0-5]\d$/.test(asistente.programacion.hora || '');
            }
            return true;
        };

        wf.alternarDia = function (dia) {
            var dias = wf.asistente.programacion.dias;
            var index = dias.indexOf(dia);
            if (index === -1) {
                dias.push(dia);
                dias.sort();
            } else {
                dias.splice(index, 1);
            }
        };

        // Guarda el workflow y, si se ha programado, su programación en la
        // misma petición (ver WorkflowsController::actionGuardar()). Uno nuevo
        // se añade al listado; uno editado pasa sus cambios al del listado.
        // Queda elegido, con sus programaciones en el panel.
        wf.guardarAsistente = function () {
            var tipo = wf.selected;
            var asistente = wf.asistente;
            var workflow = asistente.workflow;
            var datos = { id: workflow.id, titulo: (workflow.titulo || '').trim(), activo: workflow.activo, isDefault: workflow.isDefault, steps: pasosParaGuardar(workflow) };
            if (asistente.programar && wf.puedeCrearProgramacion) {
                datos.programacion = { hora: asistente.programacion.hora, dias: asistente.programacion.dias, activo: 1 };
            }

            asistente.saving = true;
            asistente.error = null;

            WorkflowsService.Guardar(tipo.type, datos, wf.espacioId).then(function (data) {
                var guardado = asistente.original || workflow;
                guardado.id = data.id;
                guardado.steps = workflow.steps.map(function (step) {
                    return { slug: step.slug, condition: condicion(step) };
                });
                guardado.titulo = datos.titulo;
                guardado.activo = !!workflow.activo;
                guardado.activoGuardado = guardado.activo;
                guardado.isDefault = !!workflow.isDefault;
                if (wf.workflows.indexOf(guardado) === -1) {
                    wf.workflows.push(guardado);
                }
                if (wf.selected === tipo) {
                    tipo.workflow = resumen(wf.workflows);
                }
                wf.elegirWorkflow(guardado);
                // La vista del espacio actualiza su resumen (ver WorkflowsEspacioController).
                $scope.$emit('workflows:guardado', guardado);
                asistenteModal.hide();
                // Se quita después de cerrarse, para que el popup no se vacíe mientras se anima.
                $timeout(function () {
                    if (wf.asistente === asistente) {
                        wf.asistente = null;
                    }
                }, 300);
            }, function (data) {
                // Si falla la programación, el workflow ya está guardado: con
                // su id, reintentar no crea otro.
                if (data && data.data && data.data.id) {
                    workflow.id = data.data.id;
                }
                asistente.error = primerError(data) || 'No se ha podido guardar el workflow.';
            }).finally(function () {
                asistente.saving = false;
            });
        };

        // La misma Task puede estar en varios tipos de contenido (una carpeta
        // por tipo, ver TaskHelper::resolve()): gana la del tipo de este
        // workflow, luego la común y, si no, la primera con ese slug.
        wf.tarea = function (slug) {
            var encontrada = null;
            for (var i = 0; i < wf.tareas.length; i++) {
                var tarea = wf.tareas[i];
                if (tarea.slug !== slug) {
                    continue;
                }
                if (tarea.tipo !== 'task' || esPropio(tarea.nodeType)) {
                    return tarea;
                }
                if (!encontrada || tarea.nodeType === 'common') {
                    encontrada = tarea;
                }
            }
            return encontrada;
        };

        // Un prompt se ve por su nombre; una Task, por su slug en texto ("enviar-email" -> "Enviar email").
        wf.tituloTarea = function (tarea) {
            if (tarea.tipo === 'prompt') {
                return tarea.description;
            }
            var titulo = tarea.slug.replace(/-/g, ' ');
            return titulo.charAt(0).toUpperCase() + titulo.slice(1);
        };

        // Catálogo de tareas para elegir la de un paso: se abre en la pestaña
        // de la tarea que ya tiene (las Tasks si no tiene ninguna).
        wf.abrirCatalogo = function (step) {
            var tarea = wf.tarea(step.slug);
            wf.catalogo = {
                step: step,
                numero: wf.asistente.workflow.steps.indexOf(step) + 1,
                pestana: tarea ? tarea.tipo : 'task',
                busqueda: '',
            };
            $timeout(function () {
                var busqueda = document.getElementById('wfCatalogoBusqueda');
                if (busqueda) {
                    busqueda.focus();
                }
            });
        };

        wf.cerrarCatalogo = function () {
            wf.catalogo = null;
        };

        // Escape cierra solo el catálogo: sin el stopPropagation llegaría al
        // modal de Bootstrap y cerraría también el asistente.
        wf.teclaCatalogo = function (event) {
            if (event.key === 'Escape') {
                event.stopPropagation();
                wf.cerrarCatalogo();
            }
        };

        // Tareas de una pestaña del catálogo ('task' o 'prompt') que coinciden
        // con la búsqueda; con nodeType, solo las de ese grupo (::gruposCatalogo()).
        // De las Tasks del sistema solo salen las del tipo de contenido de este
        // workflow (en uno del espacio, las de sus tipos) y las comunes: las de
        // otro tipo no saben trabajar con él.
        wf.tareasCatalogo = function (tipo, nodeType) {
            var texto = (wf.catalogo.busqueda || '').toLowerCase();
            return wf.tareas.filter(function (tarea) {
                if (tarea.tipo !== tipo || (nodeType !== undefined && tarea.nodeType !== nodeType)) {
                    return false;
                }
                if (tipo === 'task' && !esPropio(tarea.nodeType) && tarea.nodeType !== 'common') {
                    return false;
                }
                return !texto || [wf.tituloTarea(tarea), tarea.slug, tarea.description, tarea.prompt].some(function (campo) {
                    return (campo || '').toLowerCase().indexOf(texto) !== -1;
                });
            });
        };

        // Las Tasks del sistema van agrupadas por el tipo de contenido de su
        // carpeta (frontend\components\task\{nodeType}, ver TaskHelper):
        // primero las del tipo (o los tipos del espacio) de este workflow y
        // luego las comunes. Devuelve
        // los nodeType (strings, no objetos nuevos en cada digest) que tienen
        // alguna tarea que coincide con la búsqueda.
        wf.gruposCatalogo = function () {
            var tareas = wf.tareasCatalogo('task');

            return propios().concat('common').filter(function (nodeType, index, grupos) {
                return grupos.indexOf(nodeType) === index && tareas.some(function (tarea) {
                    return tarea.nodeType === nodeType;
                });
            });
        };

        wf.tituloGrupo = function (nodeType) {
            for (var i = 0; i < wf.tareas.length; i++) {
                if (wf.tareas[i].nodeType === nodeType) {
                    return wf.tareas[i].nodeTypeTitle || nodeType;
                }
            }
            return nodeType;
        };

        wf.elegirTarea = function (tarea) {
            wf.catalogo.step.slug = tarea.slug;
            wf.catalogo.step.nuevoPrompt = null;
            wf.cerrarCatalogo();
        };

        // "Escribir un prompt nuevo" de la pestaña de prompts: abre el
        // formulario de prompt del paso, que lo deja elegido al guardarlo.
        wf.nuevoPromptDesdeCatalogo = function () {
            wf.abrirPrompt(wf.catalogo.step);
            wf.cerrarCatalogo();
        };

        // El esfuerzo de un prompt (common\models\HermesEffort): a qué webhook
        // va y cuánto puede tardar en responder; null si no tiene ninguno.
        wf.esfuerzo = function (id) {
            for (var i = 0; i < wf.esfuerzos.length; i++) {
                if (wf.esfuerzos[i].id === id) {
                    return wf.esfuerzos[i];
                }
            }
            return null;
        };

        wf.etiquetaEsfuerzo = function (esfuerzo) {
            if (!esfuerzo) {
                return '';
            }
            return esfuerzo.minutos ? esfuerzo.nombre + ' (' + esfuerzo.minutos + ' min)' : esfuerzo.nombre;
        };

        // Formulario de prompt del paso: sin slug crea uno nuevo, con slug edita ese.
        wf.abrirPrompt = function (step) {
            step.nuevoPrompt = { slug: null, nombre: '', prompt: '', effortId: null, saving: false, error: null };
        };

        wf.editarPrompt = function (step) {
            var tarea = wf.tarea(step.slug);
            step.nuevoPrompt = { slug: tarea.slug, nombre: tarea.description, prompt: tarea.prompt, effortId: tarea.effortId || null, saving: false, error: null };
        };

        wf.cerrarPrompt = function (step) {
            step.nuevoPrompt = null;
        };

        // Crea o edita el prompt en la biblioteca del usuario y lo deja elegido
        // en el paso; al editarlo, el texto nuevo vale para todos los pasos que lo usan.
        wf.guardarPrompt = function (step) {
            var form = step.nuevoPrompt;
            var datos = { slug: form.slug, nombre: form.nombre, prompt: form.prompt, effortId: form.effortId };
            form.saving = true;
            form.error = null;

            var peticion = form.slug ? WorkflowsService.EditarPrompt(datos) : WorkflowsService.CrearPrompt(datos);
            peticion.then(function (tarea) {
                var existente = wf.tarea(tarea.slug);
                if (existente) {
                    angular.extend(existente, tarea);
                } else {
                    wf.tareas.push(tarea);
                }
                step.slug = tarea.slug;
                step.nuevoPrompt = null;
            }, function (data) {
                form.error = primerError(data) || 'No se ha podido guardar el prompt.';
            }).finally(function () {
                form.saving = false;
            });
        };

        // Un paso nuevo empieza sin tarea, con el catálogo abierto para elegirla.
        wf.agregarPaso = function (workflow) {
            var step = pasoVacio();
            workflow.steps.push(step);
            wf.abrirCatalogo(step);
        };

        wf.quitarPaso = function (workflow, index) {
            workflow.steps.splice(index, 1);
        };

        wf.moverPaso = function (workflow, index, delta) {
            var steps = workflow.steps;
            var destino = index + delta;
            if (destino < 0 || destino >= steps.length) {
                return;
            }
            var tmp = steps[destino];
            steps[destino] = steps[index];
            steps[index] = tmp;
        };

        // Nombre en el listado: su posición entre los workflows del tipo.
        // Su título (HermesWorkflow::titulo) o, sin título, "Workflow N" por su
        // posición en el listado (uno nuevo, el siguiente).
        wf.nombreWorkflow = function (workflow) {
            return workflow && workflow.titulo ? workflow.titulo : wf.nombrePorPosicion(workflow);
        };

        wf.nombrePorPosicion = function (workflow) {
            var posicion = wf.workflows.indexOf(workflow);
            return 'Workflow ' + (posicion === -1 ? wf.workflows.length + 1 : posicion + 1);
        };

        // Sus tareas en orden, para la fila del listado: "tarea → tarea → ...".
        wf.resumenPasos = function (workflow) {
            return workflow.steps.map(function (step) {
                var tarea = wf.tarea(step.slug);
                return tarea ? wf.tituloTarea(tarea) : step.slug;
            }).join(' → ');
        };

        // Programaciones del workflow de la pestaña activa (solo si ya está guardado).
        function cargarProgramaciones() {
            var workflowId = wf.workflow && wf.workflow.id;
            wf.prog = { workflowId: workflowId, lista: [], cargando: false, error: false };
            if (!workflowId || !wf.puedeProgramar) {
                return;
            }

            wf.prog.cargando = true;
            WorkflowsService.Programaciones(workflowId).then(function (lista) {
                if (wf.prog.workflowId === workflowId) {
                    wf.prog.lista = lista || [];
                }
            }, function () {
                if (wf.prog.workflowId === workflowId) {
                    wf.prog.error = true;
                }
            }).finally(function () {
                if (wf.prog.workflowId === workflowId) {
                    wf.prog.cargando = false;
                }
            });
        }

        // Resumen de los workflows guardados del tipo: solo cuentan los que tienen id.
        function resumen(workflows) {
            var guardados = workflows.filter(function (workflow) {
                return !!workflow.id;
            });
            if (!guardados.length) {
                return null;
            }
            return {
                total: guardados.length,
                activos: guardados.filter(function (workflow) {
                    return workflow.activoGuardado;
                }).length,
            };
        }

        // El orden que se guarda es siempre la posición en la lista, igual que
        // en el popup del dashboard.
        function pasosParaGuardar(workflow) {
            return workflow.steps.map(function (step, index) {
                return { slug: step.slug, orden: index + 1, condition: condicion(step) };
            });
        }

        function primerError(data) {
            var errores = (data && data.errors) || {};
            for (var campo in errores) {
                if (errores[campo] && errores[campo].length) {
                    return errores[campo][0];
                }
            }
            return null;
        }

        // Con "Siempre" no se guarda la condición, aunque se hubiera escrito antes de cambiarlo.
        function condicion(step) {
            return step.conCondicion ? (step.condition || '').trim() : '';
        }

        function pasoVacio() {
            return { slug: '', condition: '', conCondicion: false };
        }

        function vacio() {
            return { id: null, titulo: '', activo: false, activoGuardado: false, isDefault: false, steps: [] };
        }

        // Tipos de contenido del workflow: el suyo o, en uno del espacio, los del espacio.
        function propios() {
            if (!wf.selected) {
                return [];
            }
            return wf.selected.tipos || [wf.selected.type];
        }

        function esPropio(nodeType) {
            return propios().indexOf(nodeType) !== -1;
        }
    }
})();
